import { HTTP_INTERCEPTORS, HttpEvent, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpHandler, HttpRequest } from "@angular/common/http";

import { AuthService } from "../modules/auth-overriden/_services/auth.service";
import { Observable, BehaviorSubject, throwError, of } from "rxjs";
import { catchError, switchMap, filter, take, tap, map } from "rxjs/operators";
import { ActivatedRoute, Router, UrlSerializer } from "@angular/router";
import { JsonPipe } from "@angular/common";
import { PagesSnackWarningComponent } from "../pages/snack/snack.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UserModel } from "../modules/auth-overriden/_models/user.model";
// import { MatSnackBar } from '@angular/material/snack-bar';
// import { PagesSnackErrorComponent } from '../pages/snack/snack.component';

const TOKEN_HEADER_KEY = "Authorization";
const REGION = "region";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	private isRefreshing = false;
	private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	private fongesoftToken = null;
	private fongesoftURL = null;
	private fongesoftUrlSanitized = "";

	constructor(private authService: AuthService, private route: Router) {}

	private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
		if (!this.isRefreshing) {
			this.isRefreshing = true;
			this.refreshTokenSubject.next(null);

			return this.authService.refreshToken().pipe(
				catchError((error) => {
					// le refresh token est perimé, on retourne au login
					this.isRefreshing = false;
					if (error instanceof HttpErrorResponse && (error.status === 500 || error.status === 422)) {
						this.route.navigate(["auth/logout"]);
						return null;
					}
				}),
				switchMap((token: any) => {
					this.isRefreshing = false;
					this.refreshTokenSubject.next(token);
					return next.handle(this.addHeader(request, token.access_token));
				})
			);
		} else {
			return this.refreshTokenSubject.pipe(
				filter((token) => token != null),
				take(1),
				switchMap((jwt) => {
					return next.handle(this.addHeader(request, jwt));
				})
			);
		}
	}

	private addHeader(request: HttpRequest<any>, token: string) {
	
		
		// cas d'un upload de fichier
		if (request.headers.get("upload") === "file") {
			let r = request.clone({
				// withCredentials: true,
				headers: request.headers
					.set(REGION, this.authService.getRegion())
					.set(TOKEN_HEADER_KEY, "Bearer " + token)
					// .set('X-XSRF-TOKEN', "ddddddddddddddddddddddddddddddddddddd")
					.delete("upload")

			});

			return r;
		}

		/**
		 * AUTRE CA	S
		 */
		let contentType = "application/json";
		let region = null;

		if (this.authService.getRegion() != null) {
			region = this.authService.getRegion();
		}
		
		if (request.url.includes("/api/open/")) {
			region = "";
		}

		if (request.url.includes("api.ipify.org")) {
			return request.clone({
				headers: request.headers

			});
		}

		return request.clone({
			// withCredentials: true,
			headers: request.headers
				.set(REGION, region)
				.set("content-type", contentType)
				.set(TOKEN_HEADER_KEY, "Bearer " + token)
		

		});
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
		
		if (sessionStorage.getItem("history") === null) {
			sessionStorage.setItem("history", JSON.stringify({ requests: [] }));
		}

		
		/**
		 *
		 */
		let originalRequest = req;

		let token = null;
		this.urlParserFongesoft(req.urlWithParams);
		
		if (this.fongesoftToken != null) {
			// cas où la requête provient de fongesoft
			
			token = this.fongesoftToken;
			this.authService.setFongesoftAccessToken(token);
			// this.authService.setFongesoftAccessToken(JSON.stringify(token));
			sessionStorage.setItem("user", JSON.stringify(this.setDummyUser(this.fongesoftURL)));
			

		} else {
			token = this.authService.getAccessToken();
		}

		if(req.url.includes("/api/open/")){
			
			token="XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXxx"
		}

		if (token === null) {
			
			return next.handle(req);
		}

		

		// pour l'instant, on ne prends en compte que les GET
		// (data non modifiées)
		// if (req.headers.get("storerequest") === "true") {
		// 	let hist = JSON.parse(sessionStorage.getItem("history"));

		// 	let retour = null;
		// 	// boucle sur toutes les requetes enregistrées
		// 	hist.requests.forEach((storedReq, i) => {
		// 		// on supprime les requetes trop vieilles (5min)
		// 		if (Date.now() - storedReq.date > 30000) {
		// 			hist.requests.splice(i, 1);
		// 		}

		// 		// on retourne les data en memoire
		// 		if (storedReq.url === req.urlWithParams) {
		// 			retour = storedReq.data;
		// 		}
		// 	});

		// 	// on envoie la data simulée.
		// 	if (retour !== null) {
		// 		return of(new HttpResponse({ status: 200, body: retour }));
		// 	}
		// }

		// si pas de requete trouvée, on la lance pour de vrai
		return next.handle(this.addHeader(req, token)).pipe(
			tap((event) => {
				
				// if (originalRequest.headers.get("storerequest") === "true" && event instanceof HttpResponse) {
				// 	let hist = JSON.parse(sessionStorage.getItem("history"));

				// 	hist.requests.push({
				// 		url: req.urlWithParams,
				// 		body: req.serializeBody,
				// 		data: event.body,
				// 		date: Date.now(),
				// 	});
				// 	sessionStorage.setItem("history", JSON.stringify(hist));
				// }
			}),
			catchError((error) => {
				if (error instanceof HttpErrorResponse && error.status === 401) {
					return this.handle401Error(originalRequest, next);
				} else if (error instanceof HttpErrorResponse && error.status === 403) {
					this.route.navigate(["home"]);
					return null;
				}else if (error instanceof HttpErrorResponse && error.status === 0) {
					// console.log("################",error)
					this.route.navigate(["home"]);
					return null;
				} else {
					return throwError(error);
				}
			})
		);
	}

	private getCookie(name: string): string | null {

		console.log(document.cookie)
		// return "AAAAAAAAAAAAAAAAAAAAAAAAAAAAA"
		
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) {
		  return decodeURIComponent(parts.pop()?.split(';').shift() || '');
		}
		return null;
	  }

	private urlParserFongesoft(url: string) {
		let splited = url.split("\?");
		
		if (splited.length >= 2) {
			const params = splited[1].split("&");
			
			params.forEach((f, i) => {
				const param = f.split("=");
				
				param.forEach((p, j) => {
					
					if (p == "soft_token") {
						this.fongesoftToken = param[j + 1];
					}
					if (p == "url") {
						this.fongesoftURL = param[j + 1];
						//this.authService.setRegion(this.fongesoftURL)
					}
				});
			});
		}
	}

	private setDummyUser(region) {
		let u: UserModel = {
			name: "",
			email: "",
			token: "",
			region: region,
			url: region,
			identifiant: "",
			nom: "",
			prenom: "",
			role: "",
			autorisation: [],
			preferences: "",
		};
		return u;
	}
}

export const authInterceptorProviders = [{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }];
